/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiUserInformation, ApiUserProfile } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of OwnProfileController.
 */
export class OwnProfileRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /users/me/profile
     */
    public getUserProfile(): Promise<Result<ApiUserProfile>> {
        return this.http.get<Result<ApiUserProfile>>('/users/me/profile');
    }

    /**
     * Calls GET /users/me/info
     */
    public getMyUserInformation(): Promise<Result<ApiUserInformation>> {
        return this.http.get<Result<ApiUserInformation>>('/users/me/info');
    }

    /**
     * Calls POST /users/me/partnerships/{partnershipId}:accept
     */
    public acceptPartnership(partnershipId: string): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, undefined>(`/users/me/partnerships/${partnershipId}:accept`, undefined);
    }

    /**
     * Calls POST /users/me/partnerships/{partnershipId}:reject
     */
    public rejectPartnership(partnershipId: string): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, undefined>(`/users/me/partnerships/${partnershipId}:reject`, undefined);
    }

    /**
     * Calls GET /applications/me/profile
     */
    public getMyApplicationInformation(): Promise<Result<ApiUserProfile>> {
        return this.http.get<Result<ApiUserProfile>>('/applications/me/profile');
    }
}
